import { ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, Inject } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormControl, FormGroup } from '@angular/forms';
import { WebRequestService } from 'src/app/services/web-request.service';
import { LoaderComponent } from '../../../components/builders/loader/loader.component';
import { Data } from 'src/app/helper/datastore';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageSliderComponent } from '../../image-slider/image-slider.component';
import { TicketHistoryComponent } from 'src/app/modules/service-slide-show/ticket-history/ticket-history.component';

@Component({
  selector: 'app-edit-view-slide-show',
  templateUrl: './edit-view-slide-show.component.html',
  styleUrls: ['./edit-view-slide-show.component.scss'],
})
export class EditViewSlideShowComponent implements OnInit {
  // @ViewChild('slideShowModal')
  // slideShowModal: any;
  @ViewChild('slideShowModal')
  slideModal:any;
  @ViewChild('saFromUpload')
  uploadSA:any;
  @ViewChild('saFormInput', {static: false}) 
  saFormInputField:ElementRef;
  @ViewChild("warningMessageModal") warningModal: any;
  @Input()
  formValue;
  @Output()
  closeSlideShowModal = new EventEmitter();
  @ViewChild('successModal')
  successModal:any;
  @ViewChild('basicModal')
   basicModal: any;
   @ViewChild('slickModal')
  slickModalView: any;
  @ViewChild('slickModal')
  slickModal: SlickCarouselComponent;
  @Input()
  mode:any;
  slideShowData:any= [];
  LoaderComponent: any;
  slideShowCount:any;
  slideConfig:any;
  isValidSAForm:boolean = false;
  saImage:any;
  saForm:FormGroup
  saFormPhotoPath:any;
  modalBoolean:boolean = false;
  ticketId:any ="";
  responseMessage:any="";
  
  otpForm: FormGroup;
  custId:any;
  mobileNumber:any;
  isSelectedToSendOTP: any =false;
  profileId:any;
  pictureArray:any = [];
  loginData:any
  isSlideShowActivated:boolean = false;
  profileDataImages: any = [];
  glleryClicked: boolean = false;
  viewCount = 1;
  slideCount = 1;
  currentSlider = 1;
  displayValues: any[] = [];
  myProfileReqObj: any;
  allMyProfiles: any[] = [];
  aboutDataValues: any[];
  
  constructor(public service: WebRequestService,private loginDataStore: Data,public router: Router,
    public dialog: MatDialog,@Inject(MAT_DIALOG_DATA) private modalData: any,public dialogRef: MatDialogRef<EditViewSlideShowComponent>) {
    this.slideConfig =  {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      centerMode: false,
      dots: false,
      autoplaySpeed: 2000,
      autoplay: false,
      infinite: false,
      lazyLoad: "ondemand",
      method: {},
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }
      ],
    };
   }

   ngOnInit(): void {
    this.formValue = this.modalData.formValue
    this.mode = this.modalData.mode
    this.displayValues = this.modalData.display;
  }
  ngAfterViewInit(): void {
    this.slideConfig[
      'prevArrow'
    ] = `.slide-profile-left`;
    this.slideConfig[
      'nextArrow'
    ] = `.slide-profile-right`;
    this.loadBasicData();
    if(this.mode==='editView'){
      if(this.formValue){
        this.slideShowData = [];
        this.LoaderComponent = LoaderComponent;
        this.service.playSlideShowMode(this.formValue).then((response)=>{
           if(response['statusCode']===200){
             this.LoaderComponent = "";
             if(response['result'].length>0){
              this.slideShowCount = response['result'][0]['totalRows'];
              this.slideShowData = response['result'];
              this.converLakhsToCrores(this.slideShowData);
             } else{
               this.closeSlideShow();
             }
             
           } else{
             this.LoaderComponent = ""
           }
        })
      }
    }
    if(this.mode==='profileValidation'){
      if(this.formValue){
        this.slideShowData = [];
        this.LoaderComponent = LoaderComponent;
        this.service.playSlideShowModeForProfileValidation(this.formValue).then((response)=>{
           if(response['statusCode']===200){
             this.LoaderComponent = "";
             if(response['result'].length>0){
              this.slideShowCount = response['result'][0]['totalRows'];
              this.slideShowData = response['result'];
              this.converLakhsToCrores(this.slideShowData);
             } else{
               this.closeSlideShow();
             }
             
           } else{
             this.LoaderComponent = ""
           }
        })
      }
    }

    if(this.mode === 'myProfile') {
      this.slideShowData = [];
      if(this.modalData.display) {
        this.LoaderComponent = '';
        this.slideShowCount = this.modalData.formValue['totalRows'];
        this.slideShowData = this.displayValues;
        this.converLakhsToCrores(this.slideShowData);
        this.myProfileReqObj = this.modalData.reqObj
      }
    }
    // setTimeout(()=>{
    
     
    // },500)
   
  }
 

  naviagteToHoroscope(horoimg) {
    if (horoimg!= null) {
      window.open(`${horoimg}`, '_blank');

    }
  }

  loadBasicData(){
    this.loginDataStore.getStoreData('empData')
    .then((dataRes: any) => {
      this.loginData = JSON.parse(dataRes);
    })
    .catch((err) => console.error(err));
    this.saForm = new FormGroup({
      saForm : new FormControl('')
    })
    this.otpForm = new FormGroup({
      otp1: new FormControl(null, [
        Validators.required,
        Validators.maxLength(1),
        Validators.pattern('^[0-9]{1,1}$'),
      ]),
      otp2: new FormControl(null, [
        Validators.required,
        Validators.maxLength(1),
        Validators.pattern('^[0-9]{1,1}$'),
      ]),
      otp3: new FormControl(null, [
        Validators.required,
        Validators.maxLength(1),
        Validators.pattern('^[0-9]{1,1}$'),
      ]),
      otp4: new FormControl(null, [
        Validators.required,
        Validators.maxLength(1),
        Validators.pattern('^[0-9]{1,1}$'),
      ]),
      otp5: new FormControl(null, [
        Validators.required,
        Validators.maxLength(1),
        Validators.pattern('^[0-9]{1,1}$'),
      ]),
    });
  }
  afterChange(e) {
    this.slideCount = e.currentSlide;
    this.currentSlider = e.currentSlide + 1
    // console.log(this.saFormInputField)
    // this.saFormInputField.nativeElement.value = "";
    if (this.slideCount === e.currentSlide && this.slideCount < this.slideShowCount) {

      this.resetNextValues();
    } else if (e.currentSlide < this.viewCount) {
      this.resetPreviousValues(e.currentSlide);
    }
  }

  beforeChange(e) {
    // if(e.currentSlide){
    //   this.viewCount = this.slideCount;
    // }
  }

  resetNextValues() {
    if (this.slideCount === this.slideShowData.length - 4 && this.slideShowData.length < this.slideShowCount) {
      this.callNextValues();
    };

    // if (this.slideCount >= this.viewCount) {
    //   this.viewCount = this.viewCount + 1;
    // }
    if (this.currentSlider > this.viewCount) {
      this.viewCount = this.viewCount + 1;
    }
    // if (this.viewCount > this.slideCount) {
    //   this.viewCount = this.viewCount- 1;
    // }

  }

  resetPreviousValues(currentSlide) {
    this.slideCount = currentSlide;
    this.viewCount = this.viewCount - 1;
  }

  callNextValues() {
     
      if(this.mode==='editView'){
        this.formValue['intStartIndex'] = this.formValue['intEndIndex'] + 1;
        this.formValue['intEndIndex'] = this.formValue['intEndIndex'] + 10;
        this.LoaderComponent = LoaderComponent
        this.service.playSlideShowMode(this.formValue).then((response)=>{        
          this.LoaderComponent = ''
          if (response['statusCode'] === 200) {
            for (let i = 0; i < response['result'].length; i++) {
              this.slideShowData.push(response['result'][i])              
            }
            this.converLakhsToCrores(this.slideShowData);
          } else{
            this.LoaderComponent = "";
          }
        })
      }
   
      if(this.mode==='profileValidation'){
        this.formValue['startindex'] = this.formValue['endIndex'] + 1;
        this.formValue['endIndex'] = this.formValue['endIndex'] + 10;
        this.LoaderComponent = LoaderComponent
        this.service.playSlideShowModeForProfileValidation(this.formValue).then((response)=>{        
          this.LoaderComponent = ''
          if (response['statusCode'] === 200) {
            for (let i = 0; i < response['result'].length; i++) {
              this.slideShowData.push(response['result'][i])              
            }
            this.converLakhsToCrores(this.slideShowData);
          } else{
            this.LoaderComponent = "";
          }
        })
      }

      if(this.mode === 'myProfile') {
        this.myProfileReqObj['pagefrom'] = this.myProfileReqObj['pageto'] + 1;
        this.myProfileReqObj['pageto'] = this.myProfileReqObj['pageto'] + 50;
        // this.slideShowData = [];
        this.LoaderComponent = LoaderComponent;
        this.service.getMyProfiles(this.myProfileReqObj).then((res) => {
          if (res['statusCode'] === 200) {
            this.LoaderComponent = '';
            let count = res['result'].length;
            for (let i = 0; i < count; i++) {
              this.slideShowData.push(res['result'][i])
            }
            this.converLakhsToCrores(this.slideShowData);
            // this.slideShowData = this.allMyProfiles;
          } else {
            this.LoaderComponent = '';
          }
        })
      }
      
   
  }

  viewSAForm(path){
    this.saFormPhotoPath = "";
    setTimeout(()=>{
      this.saFormPhotoPath = path;
    },10)

  }

  closeSlideShow(){
    // this.slideShowModal.hide();
    // this.closeSlideShowModal.emit('');
    this.dialogRef.close();
    this.slideShowData = [];
    this.slickModalView.ngOnDestroy();
  }

  uploadSAForm(profileId){
    this.profileId=profileId;
  this.saFormInputField.nativeElement.value = "";

    this.uploadSA.show();
  }

  copyProfileId(profileId){
    console.log('>>>',profileId);
    const el = document.createElement('textarea');
    el.value = profileId;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }

  copyMobileNo(mobileNo){
    const el = document.createElement('textarea');
    el.value = mobileNo;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }
  copyEmail(email){
    const el = document.createElement('textarea');
    el.value = email;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }

  uploadSAFormImage(event) {
    this.isValidSAForm =  false;
    this.saImage = event.target.files[0];
   if(this.saImage.type==='image/jpeg'|| this.saImage.type==='image/jpg'){
    this.isValidSAForm =  false;
     this.pictureArray = [];
    this.pictureArray.push(event.target.files[0]);
   
   } else{
     this.isValidSAForm = true
   }
    
  }
  submitSAForm(){
    if(this.saImage){
      this.uploadSA.hide();
      this.LoaderComponent = LoaderComponent
      this.service.uploadSAPhoto(this.pictureArray,this.profileId).then((response)=>{
          if(response['statusCode']===200){
            this.LoaderComponent = "";
            this.responseMessage = response['message'];
            this.successModal.show();
            setTimeout(() => {
             this.successModal.hide();
           }, 5000)
          } else{
            this.LoaderComponent ="";
            this.responseMessage = response['message'];
            this.successModal.show();
            setTimeout(() => {
             this.successModal.hide();
           }, 5000)
          }
      })
    }
  }

  closeSAFormModal(){
    this.uploadSA.hide();

  }
  clearField(){
    this.saFormInputField.nativeElement.value = "";
    this.closeSAFormModal();
  }

  viewMarketingTicket(ticketId){
    this.modalBoolean=false;
    this.ticketId=""
    if(ticketId!=null){
      setTimeout(()=>{
        this.modalBoolean=true;
        this.ticketId = ticketId;
      })
    }
  }

  closeTicketModal(event){
    this.modalBoolean=false;
    this.ticketId="";
  }

  navigateToPaymentPage(profileId){
    window.open(`/paymentDetails;id=${profileId}`,'_blank');

  }

  navigateToViewProfileByProfileId(id){
    window.open(`/viewProfile;profileID=${id};format=${this.loginData.formatAccess}`, '_blank');
  }

  navigateToCommunicationLog(id){
    window.open(`/communicationLog;id=${id}`, '_blank');
  }
  verifyMobileNumber(id,mobileNumber){
    this.LoaderComponent = LoaderComponent;
    this.custId = id;
    this.mobileNumber =  mobileNumber;
    this.service.verifyMobileNumber(this.custId,3).then((response)=>{
      if(response['statusCode']===200){
       this.LoaderComponent = "";
       this.basicModal.show();
      } else{
       this.LoaderComponent = "";
        this.responseMessage = response['message'];
        this.successModal.show();
        setTimeout(() => {
         this.successModal.hide();
       }, 5000);
      }
    })
  }

  verifyEmail(id) {
    this.LoaderComponent = LoaderComponent;
    this.service.verifyTicketEmail(id).then((response)=>{
      if(response['statusCode']===200){
        this.LoaderComponent = "";
        this.responseMessage = response['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      } else{
        this.LoaderComponent = "";
      }
    })
   }
   verifyMobileOtp(){
    this.LoaderComponent = LoaderComponent;
    if (this.otpForm.invalid) {
      this.LoaderComponent = '';
      return;
    }
    const otpCode =
      this.otpForm.value.otp1 +
      '' +
      this.otpForm.value.otp2 +
      '' +
      this.otpForm.value.otp3 +
      '' +
      this.otpForm.value.otp4 +
      '' +
      this.otpForm.value.otp5;
    const otpCodeNumber = Number(otpCode);
    this.service.verifyTicketMobileOTP(this.custId,otpCodeNumber).then((response)=>{
        if(response['statusCode']===200){
          this.LoaderComponent = ""
          this.basicModal.hide();
          this.responseMessage = response['message'];
          this.warningModal.show();
          setTimeout(() => {
            this.warningModal.hide();
          }, 5000);
        } else{
          this.LoaderComponent = "";
          this.responseMessage = response['message'];
          this.warningModal.show();
          setTimeout(() => {
            this.warningModal.hide();
          }, 5000);
        }
    })
  
   }

   omit_special_char_withNumbers_custom(event) {
    const charCode = event.which ? event.which : event.keyCode;
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    if (/^[0-9\s]*$/.test(event.key)) {
      return true;
    } else {
      event.preventDefault();
      return (
        (k > 64 && k < 91) ||
        (k > 96 && k < 123) ||
        k == 8 ||
        k == 32 ||
        (k >= 48 && k <= 57)
      );
    }
  }
  
  onInputEntry(event, nextInput, previousInput, formName) {
    const input = event.target;
    const length = input.value.length;
  
    const charCode = event.inputType;
    if (charCode === 'deleteContentBackward') {
      previousInput != undefined ? previousInput.focus() : '';
    } else {
    }
  
    if (input.value.length >= input.maxLength) {
      input.value.length >= 1
        ? (input.value = input.value.slice(0, input.maxLength))
        : '';
      input.value = input.value.slice(0, 1);
      nextInput.focus();
      this.otpForm.get(formName).setValue(Number(input.value));
    }
  
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    if (k === 8) {
    }
    if (/^[0-9\s]*$/.test(event.key)) {
      return true;
    } else {
      event.preventDefault();
      return (
        (k > 64 && k < 91) ||
        (k > 96 && k < 123) ||
        k == 8 ||
        k == 32 ||
        (k >= 48 && k <= 57) ||
        length > 1
      );
    }
  }
  
  onFocusInput(event) {
    const input = event.target;
    const length = input.value.length;
  
    const charCode = event.inputType;
    if (charCode === 'deleteContentBackward') {
    } else {
    }
  }
  
  lastInput(event, previousInput, formName) {
    const input = event.target;
    const charCode = event.inputType;
    if (charCode === 'deleteContentBackward') {
      previousInput.focus();
    } else {
    }
    if (input.value.length >= input.maxLength) {
      input.value.length >= 1
        ? (input.value = input.value.slice(0, input.maxLength))
        : '';
      input.value = input.value.slice(0, 1);
      this.otpForm.get(formName).setValue(Number(input.value));
    }
  }

  isSeletedYesOrNo(value){
    if(value==='Yes'){
     this.isSelectedToSendOTP = value;
    } else{
      this.isSelectedToSendOTP = value;
      this.otpForm.reset();
     this.basicModal.hide();
    }
  
  }

  closeOTPModal(){
    this.basicModal.hide();
    this.otpForm.reset();
  }

  openMarketingSlideShow(){
    window.open(`/marketingSlideShow`,'_blank');
  }

  openMatchFowllowupSlideShow(){
    window.open(`/matchfollowup`,'_blank');
  }

  openPaymentOffer(profile) {
    if (profile['ProfileStatusID'] != 54) {
      this.responseMessage = 'This profile is not in active status';
      this.successModal.show();
      setTimeout(() => {
        this.successModal.hide();
      }, 3000);
    } else {
      this.router.navigate([]).then(res => window.open(`/membership;id=${profile['profileID']}`, '_blank'));
    }
  }

  navigateToViewOffers(profileId) {
    window.open(`/paymentOffers;id=${profileId}`, '_blank');

  }

  copyToClipBoard(profileId){
    const el = document.createElement('textarea');
    el.value = profileId;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }

  forgotPassword(profileId){
    this.LoaderComponent = LoaderComponent;
    this.service.editViewForgotPassword(profileId).then((response)=>{
      if(response['statusCode']===200){
        this.LoaderComponent = ""
          this.basicModal.hide();
          this.responseMessage = response['message'];
          this.successModal.show();
          setTimeout(() => {
            this.successModal.hide();
          }, 5000);
        } else{
          this.LoaderComponent = "";
  
        }
    })

  }

  photoRequest(profileId){
    this.LoaderComponent = LoaderComponent;
    this.service.editViewPhotoRequest(profileId,this.loginData['employeeID']).then((response)=>{
      if(response['statusCode']===200){
      this.LoaderComponent = ""
        this.basicModal.hide();
        this.responseMessage = response['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      } else{
        this.LoaderComponent = "";
        this.responseMessage = response['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      }
    })
  }

  navigateToPartnerPrefarence(id){
    window.open(`/editViewDashBoard;id=${id};type=partnerPreference`,'_blank');
  }

  navigateToSearch(id,type){
    window.open(`/searchprofile;id=${id};type=${type}`,'_blank');

  }

  navigateToMyProfile(id) {
    window.open(`/myprofile;id=${id}`, '_blank')
  }

  navigateToRegistrationValidation(){
    window.open(`/registrationprofile`,'_blank');

  }

  navigateToContact(id){
    window.open(`/editViewDashBoard;id=${id};type=contact`,'_blank');
  }

  getAssignTicketColour( element) {
    if (element === "601" || 
    (element === 601)) {
      return '#EC6227'
    } else if (element === "602" || 
    (element === 602)) {
      return '#006980'
    } else if (element === "603" || 
    (element === 603)) {
      return '#28009b'
    } else if (element === 'ProfileID') {
      return 'red'
    }
  }

  getAssignTktColour(element) {
    if (element === 1) {
      return 'green'
    } else if (element === 2) {
      return 'blue'
    } else if (element === 0) {
      return 'red'
    } else {
      return 'red'
    }
  }

  showDetails(profile) {
    this.responseMessage = profile;
    this.successModal.show();
  }

  activateSlideShow(value) {
    if (!value) {
      this.isSlideShowActivated = true;
        this.slickModal.slickPlay()
    } else {
      this.isSlideShowActivated = false;
      this.slickModal.slickPause();
    }
  }

  omit_specialChar_and_char(event) {
    let x = event.which || event.keycode;
    if ((x >= 48 && x <= 57))
      return true;
    else
      return false;
  }

  onGoToFieldChange(event) {
    if (Number.isInteger(parseInt(event.target.value))) {
      if (event.target.value > this.viewCount) {
        this.responseMessage = "Please enter number below the view profiles count !!!"
        this.warningModal.show();
        setTimeout(() => {
          this.warningModal.hide();
        }, 5000);
      } else if (event.target.value != 0 && this.viewCount != 1) {
        this.slickModal.slickGoTo(event.target.value -1);

      }

    } else if (event.target.value != "") {
      this.responseMessage = "Please enter only numerical values !!!"
      this.warningModal.show();
      setTimeout(() => {
        this.warningModal.hide();
      }, 5000);
    }
  }

  // requestViewPhoto(isPhotoAvailable,id) {
  //   if (!(isPhotoAvailable.includes('noimages') && !(isPhotoAvailable.includes('Password-Protected') && id))) {      this.profileDataImages = [];
  //     this.LoaderComponent = LoaderComponent
  //     this.service.getEditViewPhoto(id, 1).then((photoRespone) => {
  //       if (photoRespone['statusCode'] === 200) {
  //         this.LoaderComponent = "";
  //         if (photoRespone['result'] && photoRespone['result'].length > 0) {
  //           this.profileDataImages = photoRespone['result']
  //           this.glleryClicked = true;

  //         } else {
  //           this.glleryClicked = false;
  //         }

  //       }
  //     })
  //   }
  // }
  getUserPhotoGal(isPhotoAvailable, Id) {
    if (!(isPhotoAvailable.includes('noimages') && !(isPhotoAvailable.includes('Password-Protected') && Id))) {
      const custID = Id;
      let dialogRef = this.dialog.open(ImageSliderComponent, {
        width: '500px',
        // height: '551px',
        data: { custID: custID}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });
    }
  }

  getProfileTypeWithProfileID(profile) {
    if (profile['subscriptionServiceTypeId'] === 601 || profile['subscriptionServiceTypeId'] === "601") {
      return profile['profileID'] + '- R'
    } else if (profile['subscriptionServiceTypeId'] === 602 || profile['subscriptionServiceTypeId'] === "602") {
      return profile['profileID'] + '- A'
    } else if (profile['subscriptionServiceTypeId'] === 603 || profile['subscriptionServiceTypeId'] === "603") {
      const grade = profile['confidentialGrade'] != null ? ('- C' + profile['confidentialGrade']) : '- C';
      return profile['profileID'] + grade
    } else if (profile['subscriptionServiceTypeId'] === 604 || profile['subscriptionServiceTypeId'] === "604") {
      // return profile['profileID'] + '- SC'
      const type = ((profile['isSuperHighConfidential']) ? '- NX' : '- SC')
      return profile['profileID'] + type;
    } else if (profile['subscriptionServiceTypeId'] === 600 || profile['subscriptionServiceTypeId'] === "600") {
      return profile['profileID']
    } else {
      return profile['profileID']
    }
  }
  getOfficePurposeData(id) {
    let finalObject = {
      "custID": id,
      "aboutProfile": "",
      "id": null,
      "flag": 0
    }
    this.LoaderComponent = LoaderComponent;
    this.aboutDataValues = [];
    this.service.getEditViewOfficeAboutDetails(finalObject).then((response) => {
      if (response['statusCode'] === 200) {
        this.LoaderComponent = "";
        this.aboutDataValues = response['result'];
        console.log(this.aboutDataValues)
        if(this.aboutDataValues.length>0){
          const dialogRef1 = this.dialog.open(TicketHistoryComponent, {
            width: '800px',
            data: [{mainData:this.aboutDataValues, isOffice: true}]
          })
        }else{
          const dialogRef1 = this.dialog.open(TicketHistoryComponent, {
            width: '250px',
            data: [{mainData:this.aboutDataValues, isOffice: true}]
          })
        }
       
      } else {
        this.LoaderComponent = "";

      }
    })
  }

  converLakhsToCrores(records){
    for(let record of records){
      let lakhs = record.Property; 
      if(Number(lakhs) > 0)
        record.Property = this.propertyLakhsToCroresConversion(record.Property);
    }
  }

  propertyLakhsToCroresConversion(lakhsValue){ 
    let tempPropertyValue: number = lakhsValue;
    let propertyString: any;
    if(tempPropertyValue < 100){
      if(tempPropertyValue < 2)
         propertyString =  tempPropertyValue+' Lakh';
      else
        propertyString =  tempPropertyValue+' Lakhs';
    }      
    else{
      let covertedValue = tempPropertyValue / 100;
      if(covertedValue < 2){
        propertyString = covertedValue+' Crore';
      }
      else
        propertyString = covertedValue+' Crores';
    }
    return propertyString
  }

}
